"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkBrowser = checkBrowser;
var _constants = require("@studio/constants");
var _logger = require("@studio/logger");
var LOG = new _logger.StudioLogger('checkBrowser');
function checkBrowser() {
  var userAgent = navigator.userAgent;
  var isChromium = userAgent.includes('Chrome') || userAgent.includes('Chromium') || userAgent.includes('Edg');
  var message = '';
  if (!isChromium) {
    message = 'Unsupported browser';
    LOG.warn("ReadinessCheck - ".concat(message, ":"), userAgent);
  }
  return {
    status: isChromium ? _constants.PASSED : _constants.FAILED,
    data: message
  };
}